export default "__VITE_ASSET__CwrzNu5e__"